module.exports = __webpack_public_path__ + "static/media/loader.7a752b1c.gif";